import { useState } from 'react';
import { gql } from '@apollo/client';
import i18n from '@/utils/i18n';
import { InvoiceMonthSelector } from '../../../components/InvoiceMonthSelector';
import { IconButton } from '../../../components/Button/Button';
import { FaFileInvoiceDollar } from 'react-icons/all';
import { EditSection } from '../../../components/Layout';
import moment from 'moment/moment';
import { useMutation } from '@apollo/client';

const initialYear = moment()
  .subtract(1, 'months')
  .endOf('month')
  .year()
  .toString();
const initialMonth = moment()
  .subtract(1, 'months')
  .endOf('month')
  .month()
  .toString();

type InvoiceResult = {
  result: string;
  url: string;
};

export const GENERATE_INVOICE_FOR_INVOICE_COLLECTION = gql`
  mutation GenerateInvoiceForInvoiceCollection(
    $invoiceCollectionId: ID!
    $year: Int!
    $month: Int!
  ) {
    generateInvoiceForInvoiceCollection(
      invoice_collection_id: $invoiceCollectionId
      year: $year
      month: $month
    ) {
      result
      url
    }
  }
`;

export function GenerateInvoiceForInvoiceCollection({
  invoiceCollectionId,
}: {
  invoiceCollectionId: string;
}) {
  const [selectedYear, setSelectedYear] = useState(initialYear);
  const [selectedMonth, setSelectedMonth] = useState(initialMonth);
  const [generateInvoice, { data, loading: generatingInvoice, error }] =
    useMutation(GENERATE_INVOICE_FOR_INVOICE_COLLECTION);

  const [invoiceResult, setInvoiceResult] = useState<InvoiceResult | null>(
    null,
  );
  const [errors, setErrors] = useState<any[]>([]);

  async function onGenerateInvoiceClick() {
    setErrors([]);
    setInvoiceResult(null);
    try {
      await generateInvoice({
        variables: {
          invoiceCollectionId,
          year: Number(selectedYear),
          month: Number(selectedMonth),
        },
        update: (
          cache,
          {
            data: {
              generateInvoiceForInvoiceCollection: mutationInvoiceResult,
            },
          },
        ) => {
          setInvoiceResult(mutationInvoiceResult);
        },
      });
    } catch (error) {
      const { graphQLErrors } = error as any;
      setErrors(graphQLErrors as any);
      console.log(graphQLErrors);
    }
  }

  return (
    <div>
      <EditSection title={i18n.t('Invoices:invoiceGeneration')}>
        <div className="row">
          <InvoiceMonthSelector
            selectedMonth={selectedMonth}
            selectedYear={selectedYear}
            setSelectedMonth={setSelectedMonth}
            setSelectedYear={setSelectedYear}
          />
        </div>
        <div className="mb-4">
          <IconButton
            className="me-2 mb-2"
            icon={<FaFileInvoiceDollar />}
            label={i18n.t('Invoices:generateInvoice')}
            onClick={onGenerateInvoiceClick}
            isLoading={generatingInvoice}
          />
        </div>

        {errors.length > 0 && (
          <div className="mb-2">
            {errors.map((error: any) => (
              <div className="alert alert-danger" role="alert">
                {error.message}
              </div>
            ))}
          </div>
        )}
        {invoiceResult && invoiceResult.result === 'SUCCESS' && (
          <p>
            Successfully added job to the queue. You can view the status of the
            job in{' '}
            <a
              href="https://app.slack.com/client/TJ8FJPYJ0/C050NBNVADU"
              target="_blank"
              rel="noopener noreferrer"
            >
              fin-bot_invoice-updates
            </a>
            .
          </p>
        )}
      </EditSection>
    </div>
  );
}
